
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hearingaidoffers/privacy-policy",
      function () {
        return require("private-next-pages/hearingaidoffers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hearingaidoffers/privacy-policy"])
      });
    }
  